import {IMessage, IMessageType, ISystem, ISystemRole} from "../../../index";
import {EventType, TargetType} from "./fn";
import {IDialogOptions} from "../../dialog/index";

interface IParams extends IParamsData {
    dialog: IDialogOptions
}

interface IParamsData {
    system: ISystem;
    role: ISystemRole
    eventType: EventType
}

interface IMessageDefinition {
    eventType: EventType
    targetType: TargetType
    body: IMessage['body']
}

interface ITargetDefinition {
    label: string
    messageTypeId: IMessageType['id']
    targetType: TargetType
}

interface ILabels {
    body: string,
    description: string,
    descriptionLowerCase: string,
    name: string
    subject: string
}